// extracted by mini-css-extract-plugin
module.exports = {"column":"style_column__17Er0"};